/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

import Rails from '@rails/ujs';
import Turbolinks from 'turbolinks';

import 'jquery-mask-plugin';
import 'jquery-ui-dist/jquery-ui';
import 'jquery-ui-dist/jquery-ui.css';

Rails.start();
Turbolinks.start();

require.context('../images', true);

window.jQuery = jQuery;
window.$ = $;

import moment from 'moment';
moment().format();

window.moment = moment

import 'bootstrap/dist/js/bootstrap';
import '../stylesheets/application.scss';

import '../javascripts/navbar';
import '../javascripts/questions';
import '../javascripts/accessibility';
import '../javascripts/components/init';

import '../javascripts/modules/analytics/initialize';
import '../javascripts/modules/faq';
import '../javascripts/modules/questions';
import '../javascripts/modules/questions-new';
import '../javascripts/modules/contact-us-new';
import '../javascripts/modules/instance';
import '../javascripts/modules/results-show';
import '../javascripts/modules/admin/import-calendar';// Support component names relative to this directory:
var componentRequireContext = require.context("javascripts/react/components", true);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);
